import { IMessage } from '@shared/models/proto/base/messages'
import { getTransformedDate } from '@shared/utils/helpers/date-formatter'

import { Message } from '@protos/chat/message_pb'

import { IQliqChatMessage } from '@vp/models/proto/ro/qliq-chat'

export const mergeQliqChatMessages = (data: {
  callback?: (msg: IQliqChatMessage) => void
  array: IQliqChatMessage[]
}) => {
  const { array } = data
  // const messagesMap = array.reduce((acc, messages) => {
  //   return messages.reduce((acc, msg) => {
  //     callback?.(msg)
  //     return {
  //       ...acc,
  //       [msg.messageId as unknown as number]: msg,
  //     }
  //   }, acc)
  // }, {} as Record<string, QliqChatMessage>)

  return array.sort(byCreatedAtQlickChat)
}

const byCreatedAtQlickChat = (a: IQliqChatMessage, b: IQliqChatMessage) => {
  const aDate = a.message?.createdAt ?? null
  const bDate = b?.message?.createdAt ?? null

  if (!aDate || !bDate || aDate === bDate) {
    // fallback to compare ids
    return Number(b?.messageId) - Number(a?.messageId)
  }

  return aDate < bDate ? 1 : -1
}

// type Message = ChatMessage
export const mergeMessages = (data: {
  callback?: (msg: IMessage) => void
  array: IMessage[][]
}) => {
  const { callback, array } = data
  const messagesMap = array.reduce(
    (acc, messages) => {
      return messages.reduce((acc, msg) => {
        callback?.(msg)
        return {
          ...acc,
          [msg.id]: msg,
        }
      }, acc)
    },
    {} as Record<string, Message>
  )

  return Object.values(messagesMap).sort(byCreatedAt)
}

const byCreatedAt = (a: Message, b: Message) => {
  const aDate = a.createdAt ? getTransformedDate(a.createdAt) : null
  const bDate = b.createdAt ? getTransformedDate(b.createdAt) : null

  if (!aDate || !bDate || aDate.isSame(bDate)) {
    // fallback to compare ids
    return Number(b.id) - Number(a.id)
  }

  return aDate.isBefore(bDate) ? 1 : -1
}
